<template>
  <app-dialog @close="$emit('close')">
    <template #title>News</template>
    <div class="pa-3">
      <v-row dense align="center" justify="center">
        <span class="font-weight-bold body-1">What's new?</span>
        <v-col :cols="12" v-for="(item, i) in whatsNew" :key="item.title"
               class="body-2 font-weight-bold">
          {{ i+1 }}.
          <span class="">
            {{ item.title }}
          </span><br>
          <span class="font-weight-medium caption">
            {{ item.body }}
          </span>
        </v-col>
        <v-col :cols="12" v-if="comingNext.length">
          <span class="font-weight-bold body-1">Coming in the future:<br>        </span>
          <span :cols="12" v-for="item in comingNext" :key="item" class="body-2">
            &#8226; {{ item }}
          </span>
        </v-col>
      </v-row>
      <v-btn block color="success">
        <a href="https://twitter.com/musitelligence/status/1191111700499648513"
           target="_blank"
           rel="noreferrer noopener" class="white--text">
          More News...
        </a>
      </v-btn>
    </div>
  </app-dialog>
</template>

<script>
  import whatsNew from 'assets/app-data/whats-new'

  export default {
    name: 'TheNewsDialog',

    components: {
      AppDialog: () => import(/* webpackChunkName: "app-main" */ 'components/AppDialog'),
    },

    data() {
      return {
        whatsNew,
        comingNext: [],
      }
    },
  }
</script>
